// Action to call ExcessInsuranceQuoteMutation and return the price
// Do NOT import server-side mutation definitions here!
// Instead, define the mutation as a string for client-side use:


import gql from 'graphql-tag';
const EXCESS_INSURANCE_QUOTE_MUTATION = gql`
  mutation ExcessInsuranceQuote($listId: Int!, $days: Int!, $age: String!, $currency: String, $userId: String, $userEmail: String) {
    ExcessInsuranceQuoteMutation(listId: $listId, days: $days, age: $age, currency: $currency, userId: $userId, userEmail: $userEmail) {
      monthly
      annual
      daily
      currency
    }
  }
`;

import { FETCH_EXCESS_INSURANCE_PRICE_REQUEST, FETCH_EXCESS_INSURANCE_PRICE_SUCCESS, FETCH_EXCESS_INSURANCE_PRICE_FAILURE } from '../constants';

export const fetchExcessInsurancePrice = (variables) => {
  return async (dispatch, getState, { client }) => {
    try {
      dispatch({
        type: FETCH_EXCESS_INSURANCE_PRICE_REQUEST,
        payload: { loading: true }
      });

      const { data } = await client.mutate({
        mutation: EXCESS_INSURANCE_QUOTE_MUTATION,
        variables
      });
      const priceObj = data?.ExcessInsuranceQuoteMutation;
      dispatch({
        type: FETCH_EXCESS_INSURANCE_PRICE_SUCCESS,
        payload: {
          price: priceObj,
          loading: false
        }
      });
      return priceObj;
    } catch (error) {
      dispatch({
        type: FETCH_EXCESS_INSURANCE_PRICE_FAILURE,
        payload: {
          error,
          loading: false
        }
      });
      return null;
    }
  };
}

